import React from 'react'
import { classNames } from 'core/helpers/misc'

export const Field = ({ label, className, children }) => (
    <div className={classNames('form-group', className)}>
        {label && <label className="form-text">{label}</label>}
        {children}
    </div>
)
